module.exports = __webpack_public_path__ + "media/banner.56a66647.mp4";